import { graphql } from '../../../gql';

export const GET_POST_PERFORMANCE_QUERY = graphql(`
  query getPostPerformance($postId: ID!) {
    getPostPerformance(postId: $postId) {
      postId
      current { reachCount likeCount bookmarkCount replyCount }
      series { day reachCount likeCount bookmarkCount replyCount }
    }
  }
`);
